import * as React from "react";
import "./AccountSubContainer.pcss";

interface Props {
  children:React.ReactNode;
  className?: string;
}

export const AccountSubContainer = (props:Props) =>
  <div className={`account-sub-container ${props.className || ''}`}>
    {props.children}
  </div>
;
